import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../../../Login/hooks/useAuthentication';
import { Button, ButtonTheme } from '@apply/components';
import '../../../../scss/_applicationEntryNavigationButtons.scss';
import { ApplicationEntryBackButton } from './components/ApplicationEntryBackButton';
type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryNavigationButtonsProps {
    printMode?: boolean;
    nextStepButtonProps: ButtonProps;
    previousStepButtonVisible?: boolean;
    previousStepButtonClick?: React.MouseEventHandler;
}

export const ApplicationEntryNavigationButtons: React.FC<ApplicationEntryNavigationButtonsProps> = ({
    nextStepButtonProps,
    previousStepButtonVisible,
    previousStepButtonClick,
    printMode = false,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    const nextPageClick = (e: React.MouseEvent) => {
        if (nextStepButtonProps.handleClick) {
            nextStepButtonProps.handleClick(e);
        }
    };

    return (
        <>
            <div className='applicationEntry-navigationButtons'>
                <ApplicationEntryBackButton
                    previousStepButtonClick={previousStepButtonClick}
                    previousStepButtonVisible={!printMode && previousStepButtonVisible}
                />
                <Button
                    id={nextStepButtonProps.id}
                    dataTestid={nextStepButtonProps.dataTestid}
                    theme={ButtonTheme.Primary}
                    width='50%'
                    maxWidth='346px'
                    handleClick={(e) => nextPageClick(e)}
                    disabled={nextStepButtonProps.disabled}
                    visible={!printMode}
                >
                    {nextStepButtonProps.children}
                </Button>
            </div>
        </>
    );
};
